var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.markers.length > 0)?_c('div',{staticClass:"wrap-map",attrs:{"id":"map2"}}):_c('div',{staticClass:"text-center my-5"},[_c('h3',[_vm._v(_vm._s(_vm.$t('Sin resultados')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }